function Header() {
  return (
    <div className="headerBox">
      <div className="headerTextBox">
        <h1 className="headerText">
          Celebrate the skyn you're in.
          <br /> Love the skyn you're in.
        </h1>
        <p>Check out our skin care locations and pricing</p>
        <a href="https://www.instagram.com/skynlodge/" class="button">
          Check Us Out
        </a>
      </div>
    </div>
  );
}

export default Header;
